module.exports = __webpack_public_path__ + "11_2x.jpg?c23ec94b3c5b99f5004fa7fe4a42cae5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/11_2x.jpg
// module id = 18
// module chunks = 0